import { useState, useEffect } from "react";
import { useGifNichesQuery, useGifSuggestedNichesQuery } from "@/common/queries/queries";
import { INicheOption } from "../types";

export const useNicheData = (gifId: string) => {
  const [nicheFields, setNicheFields] = useState<INicheOption[]>([]);
  const [suggestNicheFields, setSuggestedNicheFields] = useState<INicheOption[]>([]);
  const [error, setError] = useState<boolean>(false);
  const [suggestError, setSuggestedError] = useState<boolean>(false);

  const {
    data: gifNiches,
    isSuccess: gifNichesSuccess,
    error: gifNichesError,
    isLoading: gifNichesLoading
  } = useGifNichesQuery(gifId, { refetchOnMount: true });

  const {
    data: gifSuggestedNiches,
    isSuccess: gifSuggestedNichesSuccess,
    error: gifSuggestedNichesError,
    isLoading: gifSuggestedNichesLoading
  } = useGifSuggestedNichesQuery(gifId, { refetchOnMount: true });

  const handleSetNicheFiled = (fields: INicheOption[]) => {
    setNicheFields(fields);
  };

  const handleSetSuggestedNicheFiled = (fields: INicheOption[]) => {
    setSuggestedNicheFields(fields);
  };

  useEffect(() => {
    if (gifNichesSuccess && gifNiches) {
      const updatedNicheFields = gifNiches.niches.map((niche) => ({
        ...niche,
        isChecked: !!niche.added
      } as INicheOption));

      handleSetNicheFiled(updatedNicheFields);
    }

    if (gifNichesError) {
      setError(true);
    }
  }, [
    gifNichesSuccess,
    gifNichesError,
    gifNiches,
  ]);

  useEffect(() => {
    if (gifSuggestedNichesSuccess && gifSuggestedNiches) {
      const updatedNicheFields = gifSuggestedNiches.niches.map((niche) => ({
        ...niche,
        added: false,
        available: true,
        isChecked: false
      } as INicheOption));

      handleSetSuggestedNicheFiled(updatedNicheFields);
    }

    if (gifSuggestedNichesError) {
      setSuggestedError(true);
    }
  }, [
    gifSuggestedNichesSuccess,
    gifSuggestedNiches,
    gifSuggestedNichesError
  ]);

  return {
    nicheFields,
    suggestNicheFields,
    handleSetNicheFiled,
    handleSetSuggestedNicheFiled,
    myNichesLoading: gifNichesLoading,
    gifSuggestedNichesLoading,
    error,
    suggestError
  };
};
